import { removeEverySecondChar } from "../../../../../features/dataFormatFunctions/dataFormatter";
import { getItemWebStorage } from "../../../../../features/webStorageSaver";
import { setHighlightObjectWKTGeometry } from "../../../../../stateManagement/reducers/MapSlice";
import { store } from "../../../../../stateManagement/store";

export async function getHighlightObjectGeometry(objectId: any, tableValueUrl: string) {
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    try {
        const response = await fetch(`${currentApiUrl}${tableValueUrl}(${objectId})/GeometryText`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        const geoText = await response.text();
        // Вызов функции, очищающей строку от лишних пробелов (если быть точным каждый второй символ удаляется)
        store.dispatch(setHighlightObjectWKTGeometry(removeEverySecondChar(geoText)));
    } catch (error) {
        // Выводим сообщение об ошибке в консоль
        console.error('Fetch error:', error);
    }
}